// extracted by mini-css-extract-plugin
export var buttonContent = "_34-0";
export var centered = "_34-1";
export var centeredFlex = "_34-2";
export var errorText = "_34-3";
export var icon = "_34-4";
export var iconButtonContent = "_34-5";
export var monospace = "_34-6";
export var padded = "_34-7";